import {
  FlowGenerationJobResult,
  WebSocketAction,
  WebSocketEntityType,
} from '@this+that/models';
import log from 'loglevel';

import type { IEventEmitter } from '../EventEmitter';
import { WebSocketEventType } from '../WebSocketContext';

export type { FlowGenerationJobResult };

export function createFlowGenerationJobMessageHandler(
  eventEmitter: IEventEmitter,
) {
  return (action: WebSocketAction, item: FlowGenerationJobResult) => {
    try {
      switch (action) {
        case WebSocketAction.INSERT:
          log.debug(
            `[FlowGenerationJobHandler] INSERT FlowGenerationJob ${item.jobId}`,
          );
          eventEmitter.emit(
            WebSocketEntityType.FlowGenerationJob,
            WebSocketEventType.INSERT,
            item,
          );
          break;
        case WebSocketAction.MODIFY:
          log.debug(
            `[FlowGenerationJobHandler] MODIFY FlowGenerationJob ${item.jobId}`,
          );
          eventEmitter.emit(
            WebSocketEntityType.FlowGenerationJob,
            WebSocketEventType.MODIFY,
            item,
          );
          break;
        case WebSocketAction.REMOVE:
          log.debug(
            `[FlowGenerationJobHandler] REMOVE FlowGenerationJob ${item.jobId}`,
          );
          eventEmitter.emit(
            WebSocketEntityType.FlowGenerationJob,
            WebSocketEventType.REMOVE,
            item,
          );
          break;
        default:
          log.warn(
            '[FlowGenerationJobHandler] Unknown action for FlowGenerationJob:',
            action,
          );
      }
    } catch (error) {
      log.error('[FlowGenerationJobHandler] Handler failed:', error);
    }
  };
}
